import script from "./ChooseScoreForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChooseScoreForm.vue?vue&type=script&setup=true&lang=ts"

import "./ChooseScoreForm.vue?vue&type=style&index=0&id=246c1605&lang=scss&scoped=true"

import exportComponent from "/home/dima/Work/pioneer-lk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-246c1605"]])

export default __exports__